import { Component, ComponentRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from 'src/app/services/modal/modal.service';
import { DmpHlGetDirectAuthentificationDmpStatus, DmpUserAuthorizationEnum } from 'src/app/utils/interfaces/new/dmp-hl-get-direct-authentification-dmp-status.interface';
import { DmpHlGetInteropCodesEnum } from 'src/app/utils/enums/dmp-hl-get-interop-codes-params.enum';
import { DmpInteropCode } from 'src/app/utils/interfaces/new/dmp-hl-get-interop-codes-response.interface';
import { DmpAuthorizationActionEnum } from 'src/app/utils/interfaces/new/dmp-hl-update-user-access-authorization-identity-params.interface';
import { DmpStatusEnum } from 'src/app/utils/enums/dmp-status.enum';
import { DmpVisibilityEnum } from 'src/app/utils/enums/dmp-visibility.enum';
import moment, { Moment } from 'moment';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { DmpHlFindDocumentsResponse } from 'src/app/utils/interfaces/new/dmp-hl-find-documents-response.interface';
import { DmpFormatEnum } from 'src/app/utils/enums/dmp-format.enum';
import { DmpParameters, DmpServiceAbstract } from 'src/app/services/dmp/dmp-service.abstract';
import { CardInfos, CpxHandleServiceAbstract, SessionTypeEnum } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { isAllowedExternalUrl } from 'src/app/utils/safe-url';
import { DocumentFormComponent, DocumentFormData, ValidOperation } from '../../modal/document-form/document-form.component';
import { AskVaccinationInfosResp } from 'src/app/pages/user/patient/dossier-patient/vaccins-alarmes/vaccination/vaccination.component';
import { LoadingModalFragment } from '../../modal/loading/loading-modal.fragment';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ConnectionType } from '../../modal/handle-cpx-modal/handle-cpx-modal.component';
import { UnauthorizedCpeCardError } from 'src/app/services/cpx-handle/cpx-handle.error';
import { DocumentService } from 'src/app/services/document/document.service';
import { DmpHlGetDocumentContentResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-document-content-response.interface';
import { DmpGetMyDocumentsResult } from 'src/app/utils/interfaces/new/dmp-get-my-documents-result.interface';
import { ActivatedRoute } from '@angular/router';
import { CpxTypeEnum } from 'src/app/utils/interfaces/new/cpx-session.interface';
import { Subscription } from 'rxjs';
import { Identity } from 'src/app/utils/interfaces/new/lecture-ins.interface';
import { DmpStep, DmpSteps } from '../dmp.component';
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, ResultEnum, TypeTargetEnum } from 'src/app/services/log-fonctionnel/log-fonctionnel.service';
import { EnumLogTableauDeBordFrontType, LogTableauDeBordService } from 'src/app/services/log-tableau-de-bord/log-tableau-de-bord.service';

const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY';
const EXPPPAT_RGX = /^EXPPAT/;
const DOCPPAT_RGX = /^DOCPAT/;

export interface AskVaccinationInfosRespPlus extends AskVaccinationInfosResp {
  cip: string;
  batchNumber: string;
}

interface NgSelectValue {
  id: string;
  libelle: string;
  meta: DmpInteropCode;
}

interface MyDocumentTableDisplay {
  title: string;
  visibility: string;
  meta: DmpGetMyDocumentsResult;
}

interface DocumentTableDisplay {
  title: string;
  description: string;
  classe: string;
  type: string;
  createdAt: string;
  actStart: string;
  actEnd: string;
  submittedAt: string;
  status: string;
  visibility: string;
  format: string;
  auteur: string;
  classification: string;
  meta: DmpHlFindDocumentsResponse;
}

export enum DmpAccessRight {
  unknow = 'unknow',
  authorized = 'authorized',
  unauthorized = 'unauthorized',
}


@Component({
  selector: 'app-display-dmp',
  templateUrl: './display-dmp.component.html',
  styleUrls: ['./display-dmp.component.scss']
})
export class DisplayDmpComponent implements OnInit, OnDestroy {

  @Input() public dmp: DmpHlGetDirectAuthentificationDmpStatus;
  @Input() public currentDmpStep: DmpStep;
  @Input() public isBrisDeGlace: boolean;
  @Input() public isSecretMode: boolean;
  @Input() public cpxAccess: ConnectionType;
  @Input() public accessRight: DmpAccessRight;
  @Input() public patientIns: string;
  @Input() public patientInsIdentity: Identity;
  @Input() public patientId: string;
  @Input() public amIMt: boolean;
  @Input() public autorisationAlimentation: boolean;
  @Output() public endDisplayDmp = new EventEmitter();
  @Output() public addDocumentToDmp = new EventEmitter();
  @Output() public changeAuthorization = new EventEmitter();

  public readonly dmpSteps = DmpSteps

  public formGroup: FormGroup;
  public dmpParamCategory: Array<NgSelectValue> = [];
  public dmpParamFormat: Array<NgSelectValue> = [];
  public dmpParamStatus: Array<string> = [];
  public dmpParamVisibility: Array<string> = [];
  public connectionTypeTmpl = ConnectionType;
  public dmpAccessRightTmpl = DmpAccessRight;

  public myDocsTable: Paginated<MyDocumentTableDisplay>;
  public myDocsTableColumnTable = [
    { title: 'Titre', data: 'title' },
    { title: 'Visibilité', data: 'visibility' },
    { title: 'Supprimer', data: null },
    { title: 'Modifier', data: null },
  ];

  public documentsTable: Paginated<DocumentTableDisplay>;
  public documentsTableColumnTable = [
    { title: 'Titre', data: 'title' },
    { title: 'Description', data: 'description' },
    { title: 'Classe', data: 'classe' },
    { title: 'Type', data: 'type' },
    { title: 'Date de création', data: 'createdAt' },
    { title: 'Date de début de l’acte', data: 'actStart' },
    { title: 'Date de fin de l’acte', data: 'actEnd' },
    { title: 'Date de soumission', data: 'submittedAt' },
    { title: 'Status', data: 'status' },
    { title: 'Visibilité', data: 'visibility' },
    { title: 'Format', data: 'format' },
    { title: 'Auteur', data: 'auteur' },
    { title: 'Classification', data: 'classification' },
    { title: 'Télécharger', data: null },
    { title: 'Supprimer', data: null },
    { title: 'Modifier', data: null },
  ];

  private _docCategoriesMap: Map<string, string> = new Map<string, string>();
  private _docTypesMap: Map<string, string> = new Map<string, string>();

  public cardType: CardInfos;
  public cardInfosTmpl = CpxTypeEnum;
  private cardTypeSub: Subscription;

  public resultHasDocFromPatient = false;

  private _logCallSrv: LogFonctionnelCallerService;
  
  constructor(
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _dmpSrv: DmpServiceAbstract,
    private _formBuilder: FormBuilder,
    private _cpxSrv: CpxHandleServiceAbstract,
    private _ref: ReferentielService,
    private _documentSrv: DocumentService,
    private _activatedRoute: ActivatedRoute,
    private _logSrv: LogFonctionnelService,
    private _logTbbSrv: LogTableauDeBordService
  ) {
    const currentProfilStr = localStorage.getItem('currentProfil');
    if (currentProfilStr && currentProfilStr !== '') {
      const currentProfil = JSON.parse(currentProfilStr);
      this._dmpSrv.resourceId = currentProfil.id;
    }

    this.cardTypeSub = this._cpxSrv.cpxCardInfos.subscribe(infos => {
      this.cardType = infos;
    });
  }

  ngOnInit(): void {
    this._logCallSrv = this._logSrv.getConfiguration(DomainEnum.Dmp);
    this._initData();
  }

  ngOnDestroy(): void {
    if (this.cardTypeSub) {
      this.cardTypeSub.unsubscribe();
    }
  }

  // public async handleTreatingPhysician(): Promise<void>{
  //   const loading = this._modalSrv.openLoading(this._viewContainerRef);

  //   try {
  //     const patientName = `${this.dmp.ExistingTestAnswer.AdminData.s_patientName} ${this.dmp.ExistingTestAnswer.AdminData.s_patientGivenName}`;
  //     const wording = !this.dmp.i_treatingPhysician
  //     ? `M’attribuer le statut de médecin traitant DMP pour le DMP de M/Mme ${patientName}.`
  //     : `Me retirer le statut de médecin traitant DMP pour le DMP de M/Mme ${patientName}.`;

  //     const modal = this._modalSrv.openModalConfirmation(
  //       this._viewContainerRef,
  //       'Confirmation',
  //       wording
  //     );

  //     const sub = modal.instance.closeEmitter.subscribe(async (res: boolean) => {
  //       if (res) {
  //         // On met à jour le statut de médecin traitant
  //         await this._updateDmpTreatingPhysicianStatus();
  //       }
  //       sub.unsubscribe();
  //     });
  //   } catch (e) {
  //     this._promptError(e.message);
  //   } finally {
  //     loading.destroy();
  //   }
  // }

  public async removeAccessAuthorization(): Promise<void>{
    if (!this.isBrisDeGlace) {
      const loading = this._modalSrv.openLoading(this._viewContainerRef);
      if (this.cpxAccess !== ConnectionType.cps && this.cpxAccess !== ConnectionType.cpf) {
        this.dmp = undefined;
        this.isBrisDeGlace = undefined;
        this.cpxAccess = undefined;
        this.endDisplayDmp.emit();
      }

      try {
        const patientName = `${this.dmp.ExistingTestAnswer.AdminData.s_patientName} ${this.dmp.ExistingTestAnswer.AdminData.s_patientGivenName}`;
        const wording = this.cpxAccess === ConnectionType.cps || this.cpxAccess === ConnectionType.cpf
        ? `Mettre fin à mon autorisation d’accès au DMP de M/Mme ${patientName}.`
        : `Mettre fin à l’autorisation d’accès de la structure de soins au DMP de M/Mme ${patientName}.`;

        const modal = this._modalSrv.openModalConfirmation(
          this._viewContainerRef,
          'Confirmation',
          wording
        );

        const sub = modal.instance.closeEmitter.subscribe(async (res: boolean) => {
          if (res) {
            // On met à jour l'autorisation d'accès
            await this._updateDmpAccessAuthorization();
            this.dmp = undefined;
            this.isBrisDeGlace = undefined;
            this.cpxAccess = undefined;
            this.endDisplayDmp.emit();
          }
          sub.unsubscribe();
        });
      } catch (e) {
        this._promptError(e.message);
      } finally {
        loading.destroy();
      }
    } else {
      const loading = this._modalSrv.openLoading(this._viewContainerRef);

      try {
        await this._dmpSrv.reinitializeConnector(this._viewContainerRef);
        this.endDisplayDmp.emit();
      } catch (e) {
        this._promptError(e.message);
      } finally {
        loading.destroy();
      }
    }
  }

  public async openWebPsSpace(): Promise<void>{
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      // On récupère les informations de l'espace Web PS
      const urls = await this._dmpSrv.hl_getwebpsdmpurls(this._viewContainerRef, this.dmp.ExistingTestAnswer.AdminData.Ins);

      if (urls) {
        // On navigue vers l'espace Web PS
        if (isAllowedExternalUrl(urls.Urls[1])) {
          window.open(urls.Urls[1]);
        } else if (isAllowedExternalUrl(urls.Urls[0])) {
          window.open(urls.Urls[0]);
        }
      } else {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Pas de lien',
          'Aucune URL n\'est disponible'
        );
      }
    } catch (e) {
      this._promptError(e.message);
    } finally {
      loading.destroy();
    }
  }

  public askChangeAuthorization(): void {
    this.changeAuthorization.emit();
  }

  public addDocumentToDMP(): void {
    this.dmp = undefined;
    this.isBrisDeGlace = undefined;
    this.cpxAccess = undefined;
    this.addDocumentToDmp.emit();
  }

  private _dmpParamHrMaxSearchPeriod: DmpParameters;
  public async searchDocuments(): Promise<void> {
    const getdmpParamHrMaxSearchPeriod = async (): Promise<number> => {
      if (!this._dmpParamHrMaxSearchPeriod) {
        this._dmpParamHrMaxSearchPeriod = await this._dmpSrv.getDmpParameters(this._viewContainerRef);
      }

      return this._dmpParamHrMaxSearchPeriod.hrMaxSearchPeriod;
    };
    const isRembSearched = (categories: Array<string>): boolean => {
      const remb_label = 'REMB';  // Donnée de remboursement.
      return categories.includes(remb_label);
    };

    const isRembSearchIncludeDate = (subStart: Moment | null | undefined): boolean => {
      const result = !!subStart;
      if (result) {
        return true;
      } else {
        prompRembSearchError(`Une recherche sur les données de remboursement doit contenir une date de début de soumission.`);
        return false;
      }
    };

    const isRembSearchDatesOk = async (subStart: Moment, subEnd: Moment): Promise<boolean> => {
      const dmpParamHrMaxSearchPeriod = await getdmpParamHrMaxSearchPeriod();
      let result = false;
      if (subEnd) {
        result = Math.abs(subEnd.diff(subStart, 'month')) < dmpParamHrMaxSearchPeriod;
      } else {
        result = Math.abs(moment().diff(subStart, 'month')) < dmpParamHrMaxSearchPeriod;
      }

      if (!result) {
        prompRembSearchError(`La période de recherche de données de remboursement ne doit pas excéder une période de ${dmpParamHrMaxSearchPeriod} mois.`);
      }
      return result
    };

    const canCallRembSearch = async (): Promise<boolean> => {
      if (!isRembSearchIncludeDate(dateStartDocumentSubmission)) {
        return false;
      }
      if (!await isRembSearchDatesOk(dateStartDocumentSubmission, dateEndDocumentSubmission)) {
        return false;
      }
      return true;
    };

    const prompRembSearchError = (msg: string) => {
      this._modalSrv.openAlert(this._viewContainerRef, 'Paramètres de recherche non valides', msg);
    };

    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    const category = this.formGroup.get('category').value as Array<string>;
    const format = this.formGroup.get('format').value as Array<string>;
    const status = this.formGroup.get('status').value as Array<string>;
    const visibility = this.formGroup.get('visibility').value as string;
    const dateStartMedicActsTop = this.formGroup.get('dateStartMedicActsTop').value;
    const dateStartMedicActsBottom = this.formGroup.get('dateStartMedicActsBottom').value;
    const dateEndMedicActsTop = this.formGroup.get('dateEndMedicActsTop').value;
    const dateEndMedicActsBottom = this.formGroup.get('dateEndMedicActsBottom').value;
    const dateStartDocumentCreation = this.formGroup.get('dateStartDocumentCreation').value;
    const dateEndDocumentCreation = this.formGroup.get('dateEndDocumentCreation').value;
    const dateStartDocumentSubmission = this.formGroup.get('dateStartDocumentSubmission').value;
    const dateEndDocumentSubmission = this.formGroup.get('dateEndDocumentSubmission').value;

    try {
      // On vérifie qu'on moins un critère de recherche soit fourni
      if ((!category || category.length === 0) && (!format || format.length === 0)
        && (!status || status.length === 0) && (!visibility || visibility === '')
        && !dateStartMedicActsTop && !dateStartMedicActsBottom && !dateEndMedicActsTop && !dateEndMedicActsBottom
        && !dateStartDocumentCreation && !dateEndDocumentCreation
        && !dateStartDocumentSubmission && !dateEndDocumentSubmission) {
        throw {
          message: 'Au moins un critère de recherche doit être renseigné'
        };
      }

      if (isRembSearched(category) && !await canCallRembSearch()) {
        return;
      }

      let categoryMap: Map<string, string>;
      if (category && category.length > 0) {
        categoryMap = new Map();

        for (const c of category) {
          categoryMap.set(c, '');
        }
      }

      let formatMap: Map<string, string>;
      if (format && format.length > 0) {
        formatMap = new Map();

        for (const c of format) {
          formatMap.set(c, '');
        }
      }

      let statusIndent: number | undefined = undefined;
      if (status && status.length > 0) {
        statusIndent = 0;
        for (const s of status) {
          statusIndent += DmpStatusEnum[s];
        }
      }

      // On lance la recherche
      const documents = await this._dmpSrv.hl_finddocuments(
        this._viewContainerRef,
        this.dmp.ExistingTestAnswer.AdminData.Ins,
        {
        Categories: categoryMap,
        Formats: formatMap,
        Practices: undefined,
        i_status: statusIndent as any,
        i_visibility: visibility && visibility !== '' ? DmpVisibilityEnum[visibility] : undefined,
        s_creationDateBottom: dateStartDocumentCreation ? (dateStartDocumentCreation as Moment).format('YYYYMMDD') : undefined,
        s_creationDateTop: dateEndDocumentCreation ? (dateEndDocumentCreation as Moment).format('YYYYMMDD') : undefined,
        s_serviceStartDateBottom: dateStartMedicActsBottom ? (dateStartMedicActsBottom as Moment).format('YYYYMMDD') : undefined,
        s_serviceStartDateTop: dateStartMedicActsTop ? (dateStartMedicActsTop as Moment).format('YYYYMMDD') : undefined,
        s_serviceStopDateBottom: dateEndMedicActsBottom ? (dateEndMedicActsBottom as Moment).format('YYYYMMDD') : undefined,
        s_serviceStopDateTop: dateEndMedicActsTop ? (dateEndMedicActsTop as Moment).format('YYYYMMDD') : undefined,
        s_submissionDateBottom: dateStartDocumentSubmission ? (dateStartDocumentSubmission as Moment).format('YYYYMMDD') : undefined,
        s_submissionDateTop: dateEndDocumentSubmission ? (dateEndDocumentSubmission as Moment).format('YYYYMMDD') : undefined,
        s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins
      });

      const session = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
      if (session) {
        await this._dmpSrv.setLastAccessDate({
          patientIns: this.patientIns,
          rpps: session.dmpConnectSessionInfos.s_internalId,
        });
      }

      if (documents) {
        this._initTablePatientsDisplay(documents);
        await this._logTbbSrv.addLogTableauDeBord({
          patientID: this.patientId,
          typeLogs: EnumLogTableauDeBordFrontType.DMP_LECTURE,
          isSuccessful: true
        });
      }
    } catch (e) {
      void this._logTbbSrv.addLogTableauDeBord({
        patientID: this.patientId,
        typeLogs: EnumLogTableauDeBordFrontType.DMP_LECTURE,
        isSuccessful: false
      }).catch(err => console.error("Erreur création log dmp lecture:", err));
      if (e instanceof UnauthorizedCpeCardError) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          e.message
        );
      } else {
        this._promptError(e.message);
      }
    } finally {
      loading.destroy();
    }
  }

  private async _displayDocMeta(file: DmpHlGetDocumentContentResponse, doc: DocumentTableDisplay): Promise<void> {
    let modalText = 'Vous pouvez télécharger le document ou visualiser ses métadonnées.';
    let buttonText = 'Télécharger';
    let buttonValue = 'download';

    let data;
    if (doc.meta.i_document_Format !== 2) {
      /**
       * le i_document_Format 2 correspond à un format RTF
       *
       * On exclu les format RTF parce qu'on ne veut pas les afficher
       * mais ils passent decodeURIComponent sans erreur
       */

      try {
        decodeURIComponent(escape(window.atob(file.s_fileContentInBase64)));

        /**
         * Si on arrive ici, c'est que decodeURIComponent de s_fileContentInBase64 c'est passé sans problème
         * On est donc sur un document affichable dans une page HTML
         */
        const tmp = await this._documentSrv.convertXmlToHtml(file.s_cdaContentInBase64);
        data = decodeURIComponent(escape(window.atob(tmp)));
        modalText = 'Vous pouvez visualiser le document ou ses métadonnées.';
        buttonText = 'Voir le document';
        buttonValue = 'display-doc';
      } catch (e) {
        // data = decodeURIComponent(escape(window.atob(file.s_fileContentInBase64)));
        /**
         * Si on arrive ici, c'est que decodeURIComponent de s_fileContentInBase64 a levé une erreur
         * On est donc sur un document non affichable dans une page HTML
         * Dans ce cas, on va convertir le XML de s_cdaContentInBase64 en HTML
         * ce qui permet de pouvoir l'afficher par la suite
         *
         * Note :
         * L'affichage du HTML de s_cdaContentInBase64 ne se fait jamais
         * puisqu'aucunes des conditions suivantes ne permettent l'affichage de 'data'
         */
        const tmp = await this._documentSrv.convertXmlToHtml(file.s_cdaContentInBase64);
        data = decodeURIComponent(escape(window.atob(tmp)));
      }
    }

    const title = `${doc.title || 'Titre inconnu'}`;
    const modal = this._modalSrv.openModalMultipleChoice(
      this._viewContainerRef,
      title,
      modalText,
      undefined,
      [
        { label: buttonText, value: buttonValue },
        { label: 'Voir les métadonnées', value: 'metadata' },
      ],
      false
    );
    await new Promise<void>((resolve) => {
      const modalSub = modal.instance.closeEmitter.subscribe(
        async (v?: string) => {
          if (v === 'download') {
            try {
              await this._downloadFile(file.s_fileContentInBase64, title);
              this._logCallSrv.addLog({
                action: ActionEnum.Read,
                result: ResultEnum.Success,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: this.patientId,
                subDomain: 'Consultation DMP',
                internals: {
                  documentTitle: title,
                  documentId: doc.meta.documentId,
                  documentIdDmp: doc.meta.s_uniqueId,
                  documentTypeCode: doc.meta.s_typeCode,
                  documentClassCode: doc.meta.s_classCode,
                  documentFormat: doc.meta.i_document_Format,
                  documentFormatDescription:
                    doc.meta.s_documentFormatDescription,
                  documentVisibility: doc.meta.i_document_Visibility,
                  auteurs: doc.meta.Authors,
                  dateCreation: doc.meta.s_creationDate,
                },
                details: `Téléchargement du document ${title}`,
              });
            } catch (e) {
              console.error(e);
              this._promptError(e.message);
              this._logCallSrv.addLog({
                action: ActionEnum.Read,
                result: ResultEnum.Error,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: this.patientId,
                subDomain: 'Consultation DMP',
                internals: {
                  error: e.message,
                  data: {
                    documentTitle: title,
                    documentId: doc.meta.documentId,
                    documentIdDmp: doc.meta.s_uniqueId,
                    documentTypeCode: doc.meta.s_typeCode,
                    documentClassCode: doc.meta.s_classCode,
                    documentFormat: doc.meta.i_document_Format,
                    documentFormatDescription:
                      doc.meta.s_documentFormatDescription,
                    documentVisibility: doc.meta.i_document_Visibility,
                    auteurs: doc.meta.Authors,
                    dateCreation: doc.meta.s_creationDate,
                  },
                },
                details: `Echec du téléchargement du document ${title}`,
              });
            }
          } else if (v === 'display-doc') {
            try {
              window.open(
                URL.createObjectURL(new Blob([data], { type: 'text/html' })),
                '_blank',
              );
              this._logCallSrv.addLog({
                action: ActionEnum.Read,
                result: ResultEnum.Success,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: this.patientId,
                subDomain: 'Consultation DMP',
                internals: { 
                 documentTitle: title, 
                 documentId: doc.meta.documentId,
                 documentIdDmp: doc.meta.s_uniqueId,
                 documentTypeCode: doc.meta.s_typeCode,
                 documentClassCode: doc.meta.s_classCode,
                 documentFormat: doc.meta.i_document_Format,
                 documentFormatDescription: doc.meta.s_documentFormatDescription,
                 documentVisibility: doc.meta.i_document_Visibility,
                 auteurs: doc.meta.Authors,
                 dateCreation: doc.meta.s_creationDate 
                },
                details: `Visualisation du document ${title}`,
              });
            } catch (e) {
              console.error(e);
              this._promptError(e.message);
              this._logCallSrv.addLog({
                action: ActionEnum.Read,
                result: ResultEnum.Error,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: this.patientId,
                subDomain: 'Consultation DMP',
                internals: { error: e.message, data: { 
                 documentTitle: title, 
                 documentId: doc.meta.documentId,
                 documentIdDmp: doc.meta.s_uniqueId,
                 documentTypeCode: doc.meta.s_typeCode,
                 documentClassCode: doc.meta.s_classCode,
                 documentFormat: doc.meta.i_document_Format,
                 documentFormatDescription: doc.meta.s_documentFormatDescription,
                 documentVisibility: doc.meta.i_document_Visibility,
                 auteurs: doc.meta.Authors,
                 dateCreation: doc.meta.s_creationDate 
                } },
                details: `Echec de la visualisation du document ${title}`,
              });
            }
          } else if (v === 'metadata') {
            try {
              window.open(
                URL.createObjectURL(
                  new Blob(
                    [
                      decodeURIComponent(
                        escape(window.atob(file.s_cdaHeadersInBase64)),
                      ),
                    ],
                    { type: 'text/html' },
                  ),
                ),
                '_blank',
              );
              
              this._logCallSrv.addLog({
                action: ActionEnum.Read,
                result: ResultEnum.Success,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: this.patientId,
                subDomain: 'Consultation DMP',
                internals: { 
                 documentTitle: title, 
                 documentId: doc.meta.documentId,
                 documentIdDmp: doc.meta.s_uniqueId,
                 documentTypeCode: doc.meta.s_typeCode,
                 documentClassCode: doc.meta.s_classCode,
                 documentFormat: doc.meta.i_document_Format,
                 documentFormatDescription: doc.meta.s_documentFormatDescription,
                 documentVisibility: doc.meta.i_document_Visibility,
                 auteurs: doc.meta.Authors,
                 dateCreation: doc.meta.s_creationDate 
                },
                details: `Visualisation des métadonnées du document ${title}`,
              });
            } catch (e) {
              console.error(e);
              this._promptError(e.message);
              this._logCallSrv.addLog({
                action: ActionEnum.Read,
                result: ResultEnum.Error,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: this.patientId,
                subDomain: 'Consultation DMP',
                internals: { error: e.message, data: { 
                 documentTitle: title, 
                 documentId: doc.meta.documentId,
                 documentIdDmp: doc.meta.s_uniqueId,
                 documentTypeCode: doc.meta.s_typeCode,
                 documentClassCode: doc.meta.s_classCode,
                 documentFormat: doc.meta.i_document_Format,
                 documentFormatDescription: doc.meta.s_documentFormatDescription,
                 documentVisibility: doc.meta.i_document_Visibility,
                 auteurs: doc.meta.Authors,
                 dateCreation: doc.meta.s_creationDate 
                } },
                details: `Echec de la visualisation des métadonnées du document ${title}`,
              });
            }
          } else if (v === 'close' || !v) {
            // ne rien faire
          }
          modal.destroy();
          modalSub.unsubscribe();
          resolve();
        },
      );
    });
  }

  public async downloadDocument(document: DocumentTableDisplay): Promise<void> {
    let concernedPerson;
    switch (document.meta.i_document_Visibility) {
      case 2:
        concernedPerson = 'le patient';
        break;
      case 8:
      case 12:
        concernedPerson = 'le représentant légal';
        break;
      case 10:
        concernedPerson = 'le patient et le représentant légal';
        break;
    }
    if (concernedPerson) {
      const modalConfirm = this._modalSrv.openModalConfirmation(
        this._viewContainerRef,
        'Visibilité document',
        `Ce document est non visible pour ${concernedPerson}.\nVoulez-vous télécharger ce document ?`
      );
      const doOpen = await new Promise<boolean>((resolve) => {
        const sub = modalConfirm.instance.closeEmitter.subscribe((res) => {
          resolve(res);
          modalConfirm.destroy();
          sub.unsubscribe();
        });
      });
      if (!doOpen) {
        return;
      }
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      // On récupère les informations nécessaires au téléchargement du fichier
      const file = await this._dmpSrv.hl_getdocumentcontent(this._viewContainerRef, {
        ins: this.dmp.ExistingTestAnswer.AdminData.Ins,
        uniqueId: document.meta.s_uniqueId,
        uuid: document.meta.s_uuid
      });

      if (file) {
        await this._displayDocMeta(file, document);
        const typeDoc = document.meta.s_classCode;
        const typeDocStr = typeDoc.indexOf('++') > -1 ? typeDoc.split('++')[0] : typeDoc;
        await this._logTbbSrv.addLogTableauDeBord({
          patientID: this.patientId,
          typeLogs: EnumLogTableauDeBordFrontType.DMP_LECTURE,
          typeDocument: typeDocStr,
          isSuccessful: true
        });
      }
    } catch (e) {
      const typeDocE = document.meta.s_classCode;
      const typeDocEStr = typeDocE.indexOf('++') > -1 ? typeDocE.split('++')[0] : typeDocE;
      void this._logTbbSrv.addLogTableauDeBord({
        patientID: this.patientId,
        typeLogs: EnumLogTableauDeBordFrontType.DMP_LECTURE,
        typeDocument: typeDocEStr,
        isSuccessful: false
      }).catch(err => console.error("Erreur création log dmp lecture:", err));
      if (e instanceof UnauthorizedCpeCardError) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          e.message
        );
      } else {
        this._promptError(e.message);
      }
    } finally {
      loading.destroy();
    }
  }

  public async deleteDocument(document: DocumentTableDisplay): Promise<void>{
    const cpxSession = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
    if (!cpxSession?.dmpConnectSessionInfos?.s_internalId || cpxSession.dmpConnectSessionInfos.s_internalId !== document.meta.Authors[0].s_hpInternalId) {
      const modal = this._modalSrv.openAlert(
        this._viewContainerRef,
        'Accès interdit',
        'Vous ne pouvez pas supprimer un document dont vous n\'êtes pas l\'auteur.'
      );
      const sub = modal.instance.closeEmitter.subscribe(() => {
        modal.destroy();
        sub.unsubscribe();
      });
      return;
    }

    const modalConfirm = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Confirmation',
      `Attention : Toute suppression de document est irréversible.\n\nVoulez-vous supprimer le document ${document.title} ?`
    );

    const confimDelete = await new Promise<boolean>(resolve => {
      const sub = modalConfirm.instance.closeEmitter.subscribe(async (res) => {
        resolve(res);
        sub.unsubscribe();
      });
    });

    if (!confimDelete) {
      return;
    }

    let confimSecretDelete = false;
    if ((DmpVisibilityEnum[document.visibility] === DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient'] as any
      || DmpVisibilityEnum[document.visibility] === DmpVisibilityEnum["Le document n'est pas visible par le patient et le représentant légal"] as any
      || DmpVisibilityEnum[document.visibility] === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient et le professionnel de santé"] as any)
      && !cpxSession.confidentialityLevel) {
      const modalSecretConfirm = this._modalSrv.openModalConfirmation(
        this._viewContainerRef,
        'Connexion secrète',
        `Ce document a été ajouté en mode connexion secrète, la suppression de ce document se fera également en connexion secrète.\n\nVoulez-vous continuer la suppression ?`
      );

      confimSecretDelete = await new Promise<boolean>(resolve => {
        const sub = modalSecretConfirm.instance.closeEmitter.subscribe(async (res) => {
          resolve(res);
          sub.unsubscribe();
        });
      });

      if (!confimSecretDelete) {
        return;
      } else {
        await this._dmpSrv.setConfidentialityLevel(this._viewContainerRef, true);
      }
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      await this._deleteDocument(document);
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Suppression terminée',
        `Le document ${document.title} a été supprimé avec succès.`
      );

      if (confimSecretDelete) {
        await this._dmpSrv.setConfidentialityLevel(this._viewContainerRef, false);
      }
    } catch (e) {
      this._promptError(e.message);
    } finally {
      loading.destroy();
    }
  }

  private async _askVaccinInfos(): Promise<AskVaccinationInfosRespPlus | undefined> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let cipCodesTmp: Array<{ id: string; libelle: string; }> = [];
        let cisCodesTmp: Array<{ id: string; libelle: string; }> = [];
        let atcCodesTmp: Array<{ id: string; libelle: string; }> = [];
        let ucdCodesTmp: Array<{ id: string; libelle: string; }> = [];
        let mvCodesTmp: Array<{ id: string; libelle: string; }> = [];

        const modal = this._modalSrv.openModalAddEdit(
          'Informations vaccin',
          this._viewContainerRef,
          {
            inputs: [
            {
              id: 'batch_number',
              label: 'N° de lot',
              placeholder: 'Renseignez le numéro de lot',
              type: 'text',
              variable: 'batch_number',
              required: true,
              validators: [Validators.required]
            },
            {
              id: 'cip_code',
              label: 'CIP',
              placeholder: 'Recherchez un CIP',
              type: 'autocomplete',
              variable: 'cip_code',
              required: true,
              validators: [Validators.required],
              searchFunction: (search): Promise<Array<{ id: string; libelle: string; }>> => {
                return new Promise<Array<{ id: string; libelle: string; }>>(async (resolve, reject) => {
                  try {
                    cipCodesTmp = await this._ref.findTerminologie('cip', undefined, search);
                    resolve(cipCodesTmp);
                  } catch (e) {
                    reject(e);
                  }
                });
              }
            }, {
              id: 'cis_code',
              label: 'CIS',
              placeholder: 'Recherchez un CIS',
              type: 'autocomplete',
              variable: 'cis_code',
              required: true,
              validators: [Validators.required],
              searchFunction: (search): Promise<Array<{ id: string; libelle: string; }>> => {
                return new Promise<Array<{ id: string; libelle: string; }>>(async (resolve, reject) => {
                  try {
                    cisCodesTmp = await this._dmpSrv.getCisCodes(this._viewContainerRef, `%${search}%`);
                    resolve(cisCodesTmp);
                  } catch (e) {
                    reject(e);
                  }
                });
              }
            }, {
              id: 'atc_code',
              label: 'ATC',
              placeholder: 'Recherchez un ATC',
              type: 'autocomplete',
              variable: 'atc_code',
              required: true,
              validators: [Validators.required],
              searchFunction: (search): Promise<Array<{ id: string; libelle: string; }>> => {
                return new Promise<Array<{ id: string; libelle: string; }>>(async (resolve, reject) => {
                  try {
                    atcCodesTmp = await this._dmpSrv.getAtcCodes(this._viewContainerRef, `%${search}%`);
                    resolve(atcCodesTmp);
                  } catch (e) {
                    reject(e);
                  }
                });
              }
            }, {
              id: 'ucd_code',
              label: 'UCD',
              placeholder: 'Recherchez un UCD',
              type: 'autocomplete',
              variable: 'ucd_code',
              searchFunction: (search): Promise<Array<{ id: string; libelle: string; }>> => {
                return new Promise<Array<{ id: string; libelle: string; }>>(async (resolve, reject) => {
                  try {
                    ucdCodesTmp = await this._ref.findTerminologie('ucd', undefined, search);
                    resolve(ucdCodesTmp);
                  } catch (e) {
                    reject(e);
                  }
                });
              }
            }, {
              id: 'mv_code',
              label: 'MV (Médicament Virtuel)',
              placeholder: 'Recherchez un MV',
              type: 'autocomplete',
              variable: 'mv_code',
              searchFunction: (search): Promise<Array<{ id: string; libelle: string; }>> => {
                return new Promise<Array<{ id: string; libelle: string; }>>(async (resolve, reject) => {
                  try {
                    mvCodesTmp = await this._ref.findTerminologie('mv', undefined, search);
                    resolve(mvCodesTmp);
                  } catch (e) {
                    reject(e);
                  }
                });
              }
            }].filter(i => !!i)
          },
          false
        );

        const findCodeFromList = (list: Array<{ id: string; libelle: string; }>, needle: string): string => {
          let rtd = '';
          const result = list.find(c => c.id === needle);
          if (result) {
            rtd = result.libelle;
          }
          return rtd;
        };

        const sub = this._modalSrv.closeEmitter.subscribe(v => {
          sub.unsubscribe();
          modal.destroy();

          if (v.loadingModal) {
            (v.loadingModal as ComponentRef<LoadingModalFragment>).destroy();
          }

          const value = v.object;

          if (value) {
            const cisDescription = findCodeFromList(cisCodesTmp, value.cis_code);
            const ucdDescriptionTmp = findCodeFromList(ucdCodesTmp, value.ucd_code);
            const ucdDescription = ucdDescriptionTmp && ucdDescriptionTmp !== '' ? ucdDescriptionTmp : undefined;
            const mvDescriptionTmp = findCodeFromList(mvCodesTmp, value.mv_code);
            const mvDescription = mvDescriptionTmp && mvDescriptionTmp !== '' ? mvDescriptionTmp : undefined;
            const cipDescriptionTmp = findCodeFromList(cipCodesTmp, value.cip_code);
            const cipDescription = cipDescriptionTmp && cipDescriptionTmp !== '' ? cipDescriptionTmp : undefined;

            resolve({
              fabricant: cisDescription,
              cis: value.cis_code,
              cisDescription,
              atc: value.atc_code,
              atcDescription: findCodeFromList(atcCodesTmp, value.atc_code),
              ucd: value.ucd_code || undefined,
              ucdDescription,
              mv: value.mv_code || undefined,
              mvDescription,
              cip: value.cip_code,
              cipDescription,
              batchNumber: value.batch_number
            } as AskVaccinationInfosRespPlus);
          } else {
            resolve(undefined);
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async openDocFormEdit(document: DocumentTableDisplay): Promise<void> {
    const cpxSession = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
    if (!cpxSession) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Non authentifié',
        'Vous n\'êtes pas authentifié.\nVeuillez vous authentifier pour modifier ce document',
        undefined,
        undefined
      );
      return;
    // } else if (document.meta.Authors[0].s_hpInternalId !== cpxSession.dmpConnectSessionInfos.s_internalId) {
    //   this._modalSrv.openAlert(
    //     this._viewContainerRef,
    //     'Modification impossible',
    //     'Vous n\'êtes pas l\'auteur de ce document.\nSeul l\'auteur d\'un document peut le modifier.',
    //     undefined,
    //     undefined
    //   );
    //   return;
    } else if (document.meta.s_typeCode === '87273-9') {
      /**
       * le TypeCode '87273-9' correspond à une note de vaccination
       */
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Note de vaccination',
        'Ce document est une note de vaccination et ne peut être édité directement.\nVous pouvez remplacer une note de vaccination depuis la page \'Vaccins, désensibilisations et alarmes\'',
        undefined,
        undefined
      );
      return;
    }
    if (document.meta.s_typeCode === '11369-6') {
      /**
       * le TypeCode '11369-6' correspond à un historique de vaccination
       */
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Note de vaccination',
        'Ce document est un historique de vaccinations et ne peut être édité.',
        undefined,
        undefined
      );
      return;
    }

    if (document.meta.i_document_Status === 2) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        'Ce document est obsolète et ne peut pas être modifié.',
        undefined,
        undefined
      );
    // } else if (document.meta.i_document_Status === 4) {
    //   this._modalSrv.openAlert(
    //     this._viewContainerRef,
    //     'Erreur',
    //     'Ce document est archivé et ne peut pas être modifié.',
    //     undefined,
    //     undefined
    //   );
    //   this._promptError('Ce document est archivé et ne peut pas être modifié.');
    } else if (document.meta.s_typeCode) {
      const modal = this._modalSrv.openModal<DocumentFormComponent>
          (this._viewContainerRef, DocumentFormComponent) as ComponentRef<DocumentFormComponent>;

      modal.instance.document = {
        category: document.meta.s_typeCode,
        formatCode: document.meta.s_documentFormatCode,
        contentInBase64: undefined,
        description: document.meta.s_description,
        eventCodes: document.meta.EventCodes,
        format: document.meta.i_document_Format,
        title: document.meta.s_title,
        visibility: document.meta.i_document_Visibility,
        uniqueId: document.meta.s_uniqueId,
        uuid: document.meta.s_uuid,
        status: document.meta.i_document_Status,
      };
      modal.instance.dmpStatus = this.dmp;
      modal.instance.isAuthor = document.meta.Authors[0].s_hpInternalId === cpxSession.dmpConnectSessionInfos.s_internalId;
      modal.instance.patientInsIdentity = this.patientInsIdentity;
      modal.instance.isMt = this.amIMt;
      modal.instance.patientId = this.patientId;

      const sub = modal.instance.closeEmitter.subscribe(async (data?: {docFormData: DocumentFormData, valideMessage: ValidOperation}) => {
        if (data?.valideMessage) {
          this._modalSrv.openAlert(this._viewContainerRef, data.valideMessage.header, data.valideMessage.message);
        }
        await this.searchDocuments();
        modal.destroy();
        sub.unsubscribe();
      });
    } else {
      const modal = this._modalSrv.openModal<DocumentFormComponent>
          (this._viewContainerRef, DocumentFormComponent) as ComponentRef<DocumentFormComponent>;

      modal.instance.document = {
        category: (document?.meta as any)?.category || undefined,
        formatCode: (document?.meta as any)?.formatCode || undefined,
        contentInBase64: undefined,
        description: (document?.meta as any)?.comment || undefined,
        eventCodes: undefined,
        format: (document?.meta as any)?.format || undefined,
        title: (document.meta as any).title,
        visibility: (document?.meta as any)?.visibility || undefined,
        uniqueId: (document.meta as any).uniqueId,
        uuid: (document.meta as any).uuid,
        status: undefined,
      };
      modal.instance.dmpStatus = this.dmp;
      modal.instance.isAuthor = true;
      // modal.instance.updateWithoutRight = true;
      modal.instance.patientInsIdentity = this.patientInsIdentity;
      modal.instance.patientId = this.patientId;
      modal.instance.docFromDb = document.meta;

      const sub = modal.instance.closeEmitter.subscribe(async (data?: {docFormData: DocumentFormData, valideMessage: ValidOperation}) => {
        // if (data?.valideMessage) {
        //   this._modalSrv.openAlert(this._viewContainerRef, data.valideMessage.header, data.valideMessage.message);
        // }
        await this._initMyDocs();
        modal.destroy();
        sub.unsubscribe();
      });
    }
  }

  private async _deleteDocument(document: DocumentTableDisplay): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      const cpxSession = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
      if (!cpxSession) {
        return;
      }

      if (DmpStatusEnum[document.status] === DmpStatusEnum['Document archivé']) {
        // On supprime le document archivé
        await this._dmpSrv.hl_deleteArchivedDocument(this._viewContainerRef, {
          s_healthcareSettings: cpxSession.PracticeLocations[cpxSession.practiceSettingIndice].s_practiceLocationActivity,
          s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins,
          s_uniqueId: document.meta.s_uniqueId,
          s_uuid: document.meta.s_uuid,
          s_title: document.title
        }, this.patientId);
      } else {
        // On supprime le document
        await this._dmpSrv.hl_deletedocument(this._viewContainerRef, {
          s_healthcareSettings: cpxSession.PracticeLocations[cpxSession.practiceSettingIndice].s_practiceLocationActivity,
          s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins,
          s_uniqueId: document.meta.s_uniqueId,
          s_uuid: document.meta.s_uuid,
          s_title: document.title
        }, this.patientId);
      }

      // On retire le document de la liste affichée
      if (this.documentsTable && this.documentsTable.objects && this.documentsTable.objects.length > 0) {
        this.documentsTable.objects.splice(
          this.documentsTable.objects.findIndex(d => d.meta.s_uniqueId === document.meta.s_uniqueId),
          1
        );
      }
    } catch (e) {
      this._promptError(e.message);
    } finally {
      loading.destroy();
    }
  }

  private async _initData(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      // On récupère les catégorie et les formats
      const interopCodes = await this._dmpSrv.hl_getInteropCodes(this._viewContainerRef, [DmpHlGetInteropCodesEnum.docTypes, DmpHlGetInteropCodesEnum.docFormats,
        DmpHlGetInteropCodesEnum.docCategories]);
      if (interopCodes && interopCodes[DmpHlGetInteropCodesEnum.docTypes]) {
        for (const docType of interopCodes[DmpHlGetInteropCodesEnum.docTypes]) {
          this.dmpParamCategory.push({
            id: docType.s_code,
            libelle: docType.s_displayName,
            meta: docType
          });

          this.dmpParamCategory = this._sortNgSelectValue(this.dmpParamCategory);

          this._docTypesMap.set(docType.s_code, docType.s_displayName);
        }
      }

      if (interopCodes && interopCodes[DmpHlGetInteropCodesEnum.docFormats]) {
        for (const docFormat of interopCodes[DmpHlGetInteropCodesEnum.docFormats]) {
          this.dmpParamFormat.push({
            id: docFormat.s_code,
            libelle: docFormat.s_displayName,
            meta: docFormat
          });

          this.dmpParamFormat = this._sortNgSelectValue(this.dmpParamFormat);
        }
      }

      if (interopCodes && interopCodes[DmpHlGetInteropCodesEnum.docCategories]) {
        for (const docCat of interopCodes[DmpHlGetInteropCodesEnum.docCategories]) {
          this._docCategoriesMap.set(docCat.s_code, docCat.s_displayName);
        }
      }

      // On récupère les statuts
      Object.keys(DmpStatusEnum).filter((v) => {
        if (isNaN(Number(v))) {
          this.dmpParamStatus.push(v);
        }
      });

      // On récupère les visibilités
      Object.keys(DmpVisibilityEnum).filter((v) => {
        if (isNaN(Number(v))) {
          this.dmpParamVisibility.push(v);
        }
      });

      this.formGroup = this._formBuilder.group({
        category: [''],
        format: [''],
        status: [[this.dmpParamStatus[0]]],
        visibility: [''],
        dateStartMedicActsBottom: [''],
        dateStartMedicActsTop: [''],
        dateEndMedicActsBottom: [''],
        dateEndMedicActsTop: [''],
        dateStartDocumentCreation: [''],
        dateEndDocumentCreation: [''],
        dateStartDocumentSubmission: [''],
        dateEndDocumentSubmission: [''],
      });

      await this._initMyDocs();
    } catch (e) {
      this._promptError(e.message);
    } finally {
      loading.destroy();
    }
  }

  public async getDocumentsSinceLastAccess(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      const session = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);

      if (session) {
        const lastAccessDate = await this._dmpSrv.getLastAccessDate({
          patientIns: this.patientIns,
          rpps: session.dmpConnectSessionInfos.s_internalId,
        });

        if (lastAccessDate) {
          this.formGroup = this._formBuilder.group({
            category: [''],
            format: [''],
            status: [[this.dmpParamStatus[0]]],
            visibility: [''],
            dateStartMedicActsBottom: [''],
            dateStartMedicActsTop: [''],
            dateEndMedicActsBottom: [''],
            dateEndMedicActsTop: [''],
            dateStartDocumentCreation: [''],
            dateEndDocumentCreation: [''],
            dateStartDocumentSubmission: [moment(lastAccessDate)],
            dateEndDocumentSubmission: [''],
          });

          this.searchDocuments();
        } else {
          this._modalSrv.openAlert(
            this._viewContainerRef, 'Aucune date trouvée',
            'Aucune date d\'un précédent accès n\'a été trouvée.'
          );
        }

        if (loading) {
          loading.destroy();
        }
      }
    } catch (e) {
      this._promptError(e.message);
    } finally {
      if (loading) {
        loading.destroy();
      }
    }
  }

  private async _initMyDocs(): Promise<void> {
    try {
      const cpxSession = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
      if (cpxSession && (cpxSession.cpxType === CpxTypeEnum.CPS || cpxSession.cpxType === CpxTypeEnum.CPF || cpxSession.cpxType === CpxTypeEnum.CPE)) {
        const docs = await this._dmpSrv.getMyDocuments({
          patientIns: this.patientIns,
          rpps: cpxSession.dmpConnectSessionInfos.s_internalId
        });
        const docsTable: Array<MyDocumentTableDisplay> = [];
        for (const doc of docs) {
          docsTable.push({
            title: doc.title,
            visibility: DmpVisibilityEnum[doc.visibility],
            meta: doc,
          });
        }

        this.myDocsTable = {
          objects: docsTable,
          page: 0,
          perpage: docsTable.length,
          total: docsTable.length
        };
      }
    } catch (e) {
      this._promptError(e.message);
    }
  }

  private async _updateDmpTreatingPhysicianStatus(): Promise<void>{
    return new Promise<void>(async (resolve, reject) => {
      try {
        /**
         * Si l'utilisateur est déjà médecin traitant
         * On retire le statut de médecin traitant
         * Sinon on donne le statut de médecin traitant
         */
        if (this.dmp.i_treatingPhysician) {
          // Ici on retire médecin traitant
          await this._dmpSrv.hl_updateuserdmpaccessauthorization(this._viewContainerRef, {
            i_action: this.dmp.ExistingTestAnswer.i_userAuthorization === DmpUserAuthorizationEnum.AuthorizationDenied
              || this.dmp.ExistingTestAnswer.i_userAuthorization === DmpUserAuthorizationEnum.AuthorizationError
              || this.dmp.ExistingTestAnswer.i_userAuthorization === DmpUserAuthorizationEnum.AuthorizationExpired
              || this.dmp.ExistingTestAnswer.i_userAuthorization === DmpUserAuthorizationEnum.NoAuthorization
              ? DmpAuthorizationActionEnum['retirer autorisation']
              : DmpAuthorizationActionEnum['ajouter autorisation'],
            i_setTreatingPhysician: false,
            s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins
          });
        } else {
          // Ici on ajoute médecin traitant
          await this._dmpSrv.hl_updateuserdmpaccessauthorization(this._viewContainerRef, {
            i_action: DmpAuthorizationActionEnum['ajouter autorisation'],
            i_setTreatingPhysician: true,
            s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins
          });
        }

        this.dmp.i_treatingPhysician = !this.dmp.i_treatingPhysician;
      } catch (e) {
        this._promptError(e.message);
        reject(e);
      }
    });
  }

  private async _updateDmpAccessAuthorization(): Promise<void>{
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._dmpSrv.hl_updateuserdmpaccessauthorization(this._viewContainerRef, {
          i_action: DmpAuthorizationActionEnum['retirer autorisation'],
          i_setTreatingPhysician: this.dmp.i_treatingPhysician,
          s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins
        });
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  private _initTablePatientsDisplay(documentsFound: Array<DmpHlFindDocumentsResponse>): void {
    const convertDocumentToListElem = (doc: DmpHlFindDocumentsResponse): DocumentTableDisplay => {
      return {
        actEnd: doc.s_serviceStopDate ? moment(doc.s_serviceStopDate).format(DATE_DISPLAY_FORMAT) : '',
        actStart: doc.s_serviceStartDate ? moment(doc.s_serviceStartDate).format(DATE_DISPLAY_FORMAT) : '',
        auteur: `${doc.Authors[0].s_hpName} ${doc.Authors[0].s_hpGiven}`,
        classe: this._docCategoriesMap.get(doc.s_classCode),
        classification: doc.s_healthCareFacilityTypeCode,
        createdAt: doc.s_creationDate ? moment(doc.s_creationDate).format(DATE_DISPLAY_FORMAT) : '',
        description: doc.s_description,
        format: DmpFormatEnum[doc.i_document_Format],
        meta: doc,
        status: DmpStatusEnum[doc.i_document_Status],
        submittedAt: doc.s_submissionDate ? moment(doc.s_submissionDate).format(DATE_DISPLAY_FORMAT) : '',
        title: doc.s_title,
        type: this._docTypesMap.get(doc.s_typeCode),
        visibility: DmpVisibilityEnum[doc.i_document_Visibility]
      };
    };

    const isDocFromPatient = (doc: DmpHlFindDocumentsResponse): boolean => {
      return EXPPPAT_RGX.test(doc.s_typeCode) || DOCPPAT_RGX.test(doc.s_typeCode) || doc.s_classCode === '90'
    };

    // On réinitialise le tableau d'affichage
    if (this.documentsTable) {
      this.documentsTable.objects = [];
    }

    const documentsTmp: Array<DocumentTableDisplay> = [];
    this.resultHasDocFromPatient = false;
    if (documentsFound && documentsFound.length > 0) {
      for (const df of documentsFound) {
        const doc = convertDocumentToListElem(df);
        if (isDocFromPatient(df)) {
          Object.defineProperty(doc, 'textColor', { configurable: true, value: 'var(--primary)' });
          this.resultHasDocFromPatient = true;
        }
        documentsTmp.push(doc);
      }

      if (this.documentsTable) {
        this.documentsTable.objects = [...documentsTmp];
        this.documentsTable.page = 0;
        this.documentsTable.perpage = 0;
        this.documentsTable.total = 0;
      } else {
        this.documentsTable = {
          objects: documentsTmp,
          page: 0,
          perpage: 0,
          total: 0
        };
      }
    }
  }

  private async _downloadFile(base64: string, fileName: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        const bytesChar = atob(base64);
        const byteNumbers = new Array(bytesChar.length);
        for (let i = 0; i < bytesChar.length; i++) {
            byteNumbers[i] = bytesChar.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);

        const reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.addEventListener('load', () => {
          const a = window.document.createElement('a');
          a.style.display = 'none';
          a.href = reader.result as string;
          a.download = fileName;
          window.document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(reader.result as string);
          window.document.body.removeChild(a);
          resolve();
        }, false);
      } catch (e) {
        reject(e);
      }
    });
  }

  private _promptError(msg: string): void {
    let contextMsg = 'Une erreur est survenue';

    const msgSplit = msg.split('\n');
    if (msgSplit.length > 1) {
      const obj = {};
      for (const str of msgSplit) {
        const strSplit = str.split(/ : (.*)/s);
        obj[strSplit[0]] = Number.isNaN(Number(strSplit[1])) ? strSplit[1] : Number(strSplit[1]);
      }
      if (typeof obj === 'object') {
        if ((obj as any).s_apiErrorTypeDescription === 'DMPError') {
          contextMsg = `${(obj as any).s_apiErrorDescription}`;
          contextMsg += `\n${(obj as any).s_apiErrorDmpErrorDetails}`;

          msg = `Code d'erreur : ${(obj as any).s_apiErrorDmpErrorCode}`;
          msg += `\nType de l'erreur : ${(obj as any).s_apiErrorTypeDescription}`;
          msg += `\nContexte de l'erreur : ${(obj as any).s_apiErrorContext}`;
          msg += `\nDétails de l'erreur : ${(obj as any).s_apiErrorExtendedInformations}`;
        } else if ((obj as any).s_apiErrorTypeDescription === 'ApiError') {
          contextMsg = `Code d'erreur : ${(obj as any).i_apiErrorCode}`;
          contextMsg += `\nType de l'erreur : ${(obj as any).s_apiErrorTypeDescription}`;
          contextMsg += `\nContexte de l'erreur : ${(obj as any).s_apiErrorContext}`;
          contextMsg += `\nDescription de l'erreur : ${(obj as any).s_apiErrorDescription}`;
          contextMsg += `\nDétails de l'erreur : ${(obj as any).s_apiErrorExtendedInformations}`;
          msg = undefined;
        } else if ((obj as any).s_status && ((obj as any).s_status === 'ERROR' || (obj as any).s_status === 'API_ERROR')) {
          contextMsg = (obj as any).s_apiErrorDescription ? (obj as any).s_apiErrorDescription : contextMsg;
          if ((obj as any).s_apiErrorDmpErrorCode && (obj as any).s_apiErrorTypeDescription && (obj as any).s_apiErrorDmpErrorDetails) {
            msg = `Code d'erreur : ${(obj as any).s_apiErrorDmpErrorCode}`;
            msg += `\nType de l'erreur : ${(obj as any).s_apiErrorTypeDescription}`;
            msg += `\nContexte de l'erreur : ${(obj as any).s_apiErrorContext}`;
            msg += `\nDétails de l'erreur : ${(obj as any).s_apiErrorDmpErrorDetails}`;
          } else {
            msg = (obj as any).s_apiErrorDmpErrorDetails ? (obj as any).s_apiErrorDmpErrorDetails : msg;
          }
        }

        if ((obj as any).s_requestFrameInBase64) {
          console.error('Message d\'erreur pour le support (request) : ', (obj as any).s_requestFrameInBase64);
        }
        if ((obj as any).s_answerFrameInBase64) {
          console.error('Message d\'erreur pour le support (response) : ', (obj as any).s_answerFrameInBase64);
        }
      }
    }

    this._modalSrv.openAlert(
      this._viewContainerRef,
      'Erreur',
      contextMsg,
      undefined,
      msg
    );
  }

  private _sortNgSelectValue(arr: Array<NgSelectValue>): Array<NgSelectValue> {
    return arr.sort((a, b) => {
      if (a.libelle > b.libelle) {
        return 1;
      }
      if (b.libelle > a.libelle) {
        return -1;
      }
      return 0;
    });
  }

  public async deleteDocFromUser(doc: MyDocumentTableDisplay): Promise<void> {
    const cpxSession = await this._cpxSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
    if (!cpxSession) {
      return;
    }
    const modalConfirm = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Confirmation de suppression',
      `Attention : Toute suppression de document est irréversible.\n\nVoulez-vous supprimer le document ${document.title} ?`
    );

    const confirmSub = modalConfirm.instance.closeEmitter.subscribe(async v => {
      confirmSub.unsubscribe();
      modalConfirm.destroy();
      if (v) {

        let secretConfirm = false;

        if (doc.meta.createdWithSecretmode && !cpxSession.confidentialityLevel) {
          const modalSecretConfirm = this._modalSrv.openModalConfirmation(
            this._viewContainerRef,
            'Connexion secrète',
            `Ce document a été ajouté en mode connexion secrète, la suppression de ce document se fera également en connexion secrète.\n\nVoulez-vous continuer la suppression ?`
          );
          secretConfirm = await new Promise<boolean>(resolve => {
            const subSecretConfirm = modalSecretConfirm.instance.closeEmitter.subscribe(vSecretConfirm => {
              resolve(vSecretConfirm);
              modalSecretConfirm.destroy();
              subSecretConfirm.unsubscribe();
            });
          });
          if (!secretConfirm) {
            return;
          } else {
            await this._dmpSrv.setConfidentialityLevel(this._viewContainerRef, true);
          }
        }

        const loading = this._modalSrv.openLoading(this._viewContainerRef);

        try {
          await this._dmpSrv.hl_deletedocument(
            this._viewContainerRef,
            {
              s_healthcareSettings: cpxSession.PracticeLocations[cpxSession.practiceSettingIndice].s_practiceLocationActivity,
              s_ins: this.dmp.ExistingTestAnswer.AdminData.Ins,
              s_uniqueId: doc.meta.uniqueId,
              s_uuid: doc.meta.uuid,
              s_title: doc.meta.title
            },
            this.patientId
          );
          await this._dmpSrv.deleteFromMyDocuments(doc.meta.uniqueId);
          this._modalSrv.openAlert(
            this._viewContainerRef,
            'Suppression terminée',
            `Le document ${doc.meta.title} a été supprimé avec succès.`
          );

          if (secretConfirm) {
            await this._dmpSrv.setConfidentialityLevel(this._viewContainerRef, false);
          }

          await this._initMyDocs();
        } catch (e) {
          this._promptError(e.message);
        } finally {
          loading.destroy();
        }
      }
    });
  }

}
